module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAACOSURBVDiNxVLBCYAwEEucxBFcyUl0A0dwBTdwBEdwBLtB/Jwg51WLCAYKJXcJ1+YAB0mrpLWUv0CGUr6yYucb5BDwHQDwIB9HC0CS1Rvhp/j/CaUGCUALYAqrPjJJy+m+SWqsb46i9QaDcaMTj7nd8AZnUZ0T3xl4k1B8GNzFmOzUuZ8lyc/2oH+h7wFgB1kVG9R77lh+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/signed.png
// module id = LFz6
// module chunks = 1